import UISideNavItem from 'UIComponents/nav/UISideNavItem';
import unescapedText from 'I18n/utils/unescapedText';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { ScreenReaderOnly } from 'foundations-components/transitional/components/ScreenReaderOnly';
import UniversalAssociationsSelectSideNavAccessibilityMessage from './UniversalAssociationsSelectSideNavAccessibilityMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UniversalAssociationsSelectSideAllAssociationsNavItem = ({
  allAssociationsCount,
  selectedObjectTypeId,
  onSetSelectedObjectTypeId
}) => {
  const selectedAssociationsLabel = unescapedText('universalAssociationsSelect.selectedAssociationsLabel');
  const handleSelectNavItem = () => onSetSelectedObjectTypeId(undefined);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UISideNavItem, {
      "data-test-id": 'universal-associations-select-nav-item-all-associations',
      "data-selenium-test": "association-nav",
      "data-selenium-value": selectedAssociationsLabel,
      "aria-describedby": 'universal-associations-select-nav-item-all-associations',
      title: /*#__PURE__*/_jsx(TruncateString, {
        children: selectedAssociationsLabel
      }),
      active: !selectedObjectTypeId,
      style: !selectedObjectTypeId ? {
        fontWeight: 'bold'
      } : {},
      count: allAssociationsCount,
      onClick: handleSelectNavItem
    }), /*#__PURE__*/_jsx(ScreenReaderOnly, {
      children: /*#__PURE__*/_jsx("div", {
        id: 'universal-associations-select-nav-item-all-associations',
        children: /*#__PURE__*/_jsx(UniversalAssociationsSelectSideNavAccessibilityMessage, {
          pluralObjectName: selectedAssociationsLabel,
          count: allAssociationsCount
        })
      })
    })]
  });
};
export default UniversalAssociationsSelectSideAllAssociationsNavItem;